import React from "react";
import { FormattedMessage } from "@irati/utils/lang";
var Field = function (_a) {
    var label = _a.label, description = _a.description;
    return (React.createElement("li", null,
        React.createElement("strong", null,
            React.createElement(FormattedMessage, { id: label })),
        "\u00A0-\u00A0",
        React.createElement(FormattedMessage, { id: description })));
};
export default Field;
